import { render, staticRenderFns } from "./imgB.vue?vue&type=template&id=36558509"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36558509')) {
      api.createRecord('36558509', component.options)
    } else {
      api.reload('36558509', component.options)
    }
    module.hot.accept("./imgB.vue?vue&type=template&id=36558509", function () {
      api.rerender('36558509', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgB.vue"
export default component.exports